import { Pinia, Store } from 'pinia-class-component';
import { Group, GroupUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'GroupStore',
  name: 'GroupStore',
})
export default class GroupStore extends Pinia {
  private readonly api = initClient(GroupUiClient);

  //data
  private _loadingPromise: Promise<Group[]> | null = null;
  private _groups: Group[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get groups(): Group[] {
    return this._groups;
  }

  get groupsById(): Map<string, Group> {
    return new Map(this._groups.map(e => [e.id, e]));
  }

  get groupsByFeature(): Map<string, Group[]> {
    const ret = new Map<string, Group[]>();
    this._groups.forEach(e => {
      if (!ret.has(e.feature)) {
        ret.set(e.feature, []);
      }
      ret.get(e.feature)!.push(e);
    });
    return ret;
  }

  //actions
  clear(): void {
    this._groups.splice(0);
  }

  setGroups(groups: Group[]): void {
    this._groups.splice(0);
    this._groups.push(...groups);
  }

  rememberGroup(group: Group): void {
    const index = this._groups.findIndex(e => e.id === group.id);
    if (index >= 0) {
      this._groups.splice(index, 1, group);
    } else {
      this._groups.push(group);
    }
  }

  forgetGroup(group: Group): void {
    const index = this._groups.findIndex(e => e.id === group.id);
    if (index >= 0) {
      this._groups.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const groups = await this._loadingPromise;
      this.setGroups(groups);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._groups.length > 0) {
      return;
    }
    return await this.reload();
  }
}